import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'max',
})
export class MaxPipe implements PipeTransform {
  constructor() {}

  public transform(value: number, toCompare: number): unknown {
    return Math.max(value, toCompare);
  }
}
